import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        housingMode: null,
        searchStr: ''
    },
    getters : {
        HOUSING_MODE: state => {
            return state.housingMode;
        },

        SEARCH_STR: state => {
            return state.searchStr;
        }
    },
    mutations: {
        SET_HOUSING_MODE: (state, payload) => {
            state.housingMode = payload;
        },

        SET_SEARCH_STR: (state, payload) => {
            state.searchStr = payload;
        }
    },
    actions : {
        GET_HOUSING_MODE : async (context,payload) => {
            context.commit('SET_HOUSING_MODE',payload)
         },
        SAVE_HOUSING_MODE : async (context,payload) => {
            context.commit('SET_HOUSING_MODE',payload)
         },

        GET_SEARCH_STR: async (context,payload) => {
            context.commit('SET_SEARCH_STR',payload)
        },

        SAVE_SEARCH_STR: async (context,payload) => {
            context.commit('SET_SEARCH_STR',payload)
        },
    }  
})